import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaBuilding, FaRegImages, FaMobileAlt, FaSearch, FaUsers, FaCode, FaRocket, FaPencilRuler, FaMapMarkerAlt, FaClipboardCheck } from 'react-icons/fa';

const WebArquitectosPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-empresas", text: "Página web barata para empresas" },
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-constructoras", text: "Página web barata para constructoras" },
    { url: "/servicios/landing-pages", text: "Landing pages económicas" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Capta clientes de mayor valor",
      description: "Una web profesional atrae proyectos más ambiciosos. Los clientes con presupuestos elevados buscan arquitectos con presencia online profesional."
    },
    {
      title: "Exhibe tus proyectos 24/7",
      description: "Tu portfolio online trabaja cuando tú descansas. Presenta tus mejores trabajos con fotografías profesionales y descripciones técnicas detalladas."
    },
    {
      title: "Diferénciate de la competencia",
      description: "El 80% de los estudios de arquitectura tienen webs anticuadas o poco atractivas. Destaca con un diseño moderno que refleje tu visión arquitectónica."
    },
    {
      title: "Expande tu radio de acción",
      description: "Consigue proyectos más allá de tu localidad. Una web optimizada te posiciona para captar clientes en toda España e incluso internacionales."
    },
    {
      title: "Genera credibilidad instantánea",
      description: "El 76% de los clientes investigan online antes de contactar. Una web profesional establece confianza y autoridad desde el primer vistazo."
    },
    {
      title: "Retorno de inversión con un solo proyecto",
      description: "Con un único proyecto mediano captado a través de la web, recuperas varias veces la inversión total. Cada proyecto adicional es beneficio neto."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaRegImages />,
      title: "Portfolio visual de impacto",
      description: "Galería de proyectos con imágenes de alta calidad, vídeos y renders 3D. Presentación impactante de tus obras más destacadas para causar la mejor impresión."
    },
    {
      icon: <FaMobileAlt />,
      title: "Diseño responsive avanzado",
      description: "Tu web se adaptará perfectamente a cualquier dispositivo. Las imágenes y planos se visualizarán con detalle tanto en móviles como en pantallas grandes."
    },
    {
      icon: <FaBuilding />,
      title: "Categorización inteligente de proyectos",
      description: "Organización por tipo de obra (residencial, comercial, rehabilitación), estilo o ubicación. Facilita que los clientes encuentren referencias similares a sus necesidades."
    },
    {
      icon: <FaSearch />,
      title: "SEO para arquitectos",
      description: "Posicionamiento específico para términos como 'arquitecto en [tu ciudad]' o especialidades concretas. Aparece cuando los clientes buscan tus servicios."
    },
    {
      icon: <FaPencilRuler />,
      title: "Presentación de servicios detallada",
      description: "Secciones específicas para cada servicio: diseño, project management, certificaciones energéticas, etc. Claridad para el cliente sobre todo lo que ofreces."
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Optimización local integrada",
      description: "Configuración para Google Business Profile y presencia en mapas. Destaca cuando busquen arquitectos en tu zona con información consistente en todas las plataformas."
    }
  ];
  
  // Planes de precios adaptados
  const plans = [
    {
      title: 'Web para Arquitectos Básica',
      price: 350,
      period: 'pago único',
      description: 'Web profesional para comenzar a destacar tu estudio de arquitectura online.',
      features: [
        { text: 'Diseño personalizado profesional', included: true },
        { text: 'Adaptación a todos los dispositivos', included: true },
        { text: 'Portfolio de hasta 10 proyectos', included: true },
        { text: 'Sección de servicios', included: true },
        { text: 'Formulario de contacto', included: true },
        { text: 'Optimización SEO básica', included: true },
        { text: 'Integración con Google Maps', included: true },
        { text: 'Enlaces a redes sociales', included: true },
        { text: 'Galería lightbox para detalles', included: false },
        { text: 'Filtros de portfolio por categorías', included: false },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=arquitecto-basica',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web para Arquitectos Profesional',
      price: 550,
      period: 'pago único',
      description: 'La más elegida. Web completa con portfolio avanzado para captar clientes de calidad.',
      features: [
        { text: 'Diseño premium exclusivo', included: true },
        { text: 'Adaptación responsive avanzada', included: true },
        { text: 'Portfolio ilimitado con categorías', included: true },
        { text: 'Página detallada para cada proyecto', included: true },
        { text: 'Filtros de búsqueda por tipo de obra', included: true },
        { text: 'Presentación del equipo profesional', included: true },
        { text: 'Blog para posicionamiento SEO', included: true },
        { text: 'Optimización SEO avanzada', included: true },
        { text: 'Galería lightbox con zoom', included: true },
        { text: 'Configuración Google Business Profile', included: true },
      ],
      isPopular: true,
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=arquitecto-pro',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web para Arquitectos Premium',
      price: 850,
      period: 'pago único',
      description: 'Experiencia web de alta gama para estudios que buscan destacar en el mercado.',
      features: [
        { text: 'Diseño exclusivo de alta gama', included: true },
        { text: 'Portfolio interactivo avanzado', included: true },
        { text: 'Visualización 3D de proyectos', included: true },
        { text: 'Integración con redes sociales', included: true },
        { text: 'Videos de recorridos virtuales', included: true },
        { text: 'Área de clientes privada', included: true },
        { text: 'Blog con contenido inicial SEO', included: true },
        { text: 'Estrategia SEO completa', included: true },
        { text: 'Multicategorías y etiquetas', included: true },
        { text: 'Sistema de citas para consultas', included: true },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=arquitecto-premium',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis y planificación",
      description: "Estudiamos tu estudio, proyectos destacados y estilo arquitectónico. Planificamos una web que refleje fielmente tu visión y filosofía profesional.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Diseño y desarrollo",
      description: "Creamos una web con diseño que complementa tu estética arquitectónica. Implementamos el portfolio visual y todas las funcionalidades necesarias.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y posicionamiento",
      description: "Publicamos tu web, te formamos en su uso y configuramos estrategias SEO para que te encuentren los clientes adecuados para tus servicios.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño que refleja tu visión arquitectónica",
      us: true,
      others: false
    },
    {
      label: "Portfolio optimizado para arquitectos",
      us: true,
      others: false
    },
    {
      label: "Posicionamiento SEO especializado",
      us: true,
      others: false
    },
    {
      label: "Optimización de imágenes de alta calidad",
      us: true,
      others: false
    },
    {
      label: "Capacidad para proyectos extensos",
      us: true,
      others: false
    },
    {
      label: "Formación en actualización de contenidos",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Durante años dependí exclusivamente de recomendaciones y contactos para conseguir proyectos. Desde que lanzamos la web profesional, hemos captado clientes que nunca habrían llegado a nosotros por vías tradicionales. El portfolio online nos permite mostrar nuestro trabajo a potenciales clientes antes de la primera reunión, lo que ha mejorado significativamente la calidad de los contactos. Hemos conseguido dos proyectos importantes directamente a través de la web que han multiplicado por diez la inversión realizada.",
    author: "Carlos Mendoza",
    position: "Arquitecto fundador",
    company: "Estudio Mendoza Arquitectura",
    avatar: "/servicios/testimonios/arquitecto.webp"
  };
  
  const founderMessage = "El sector de la arquitectura es único: combina visión artística con precisión técnica. Las páginas web para arquitectos deben reflejar esta dualidad, mostrando proyectos con impacto visual mientras transmiten rigor profesional. Un buen portfolio digital se convierte en la extensión natural del trabajo arquitectónico.";
  
  // FAQs específicas para web de arquitectos
  const faqs = [
    {
      question: "¿Por qué necesito una web profesional como arquitecto?",
      answer: "Una web profesional es actualmente indispensable para los arquitectos por varios motivos estratégicos: 1) Es tu portfolio digital disponible 24/7, mostrando tus proyectos cuando los clientes buscan fuera de horario laboral; 2) El 83% de los clientes potenciales investigan online antes de contactar con un profesional; 3) Proporciona credibilidad instantánea y primera impresión profesional; 4) Expande tu alcance geográfico, permitiéndote captar proyectos más allá de tu localidad; 5) Te posiciona como experto en especialidades concretas (sostenibilidad, reformas, diseño interior, etc.); 6) Diferencia tu estudio de la competencia mediante diseño y contenido de calidad; 7) Atrae proyectos de mayor envergadura y presupuesto, ya que clientes con inversiones importantes buscan arquitectos con presencia digital profesional; 8) Muestra testimonios y estudios de caso que refuerzan tu experiencia. Según datos del sector, los arquitectos con presencia online profesional consiguen un 40% más de consultas cualificadas que aquellos que dependen exclusivamente del boca a boca tradicional.",
      category: "Estrategia"
    },
    {
      question: "¿Cómo presentarán mis proyectos en la web?",
      answer: "Tu portfolio de proyectos arquitectónicos recibirá un tratamiento especial con estas características: 1) Sistema de galerías de alta calidad que mantiene la resolución de tus imágenes y planos, con visualización ampliada y zoom para apreciar detalles; 2) Organización en categorías personalizadas según tus especialidades (residencial, comercial, rehabilitación, sostenible, etc.); 3) Página individual detallada para cada proyecto importante con múltiples imágenes, descripción técnica, retos superados y soluciones implementadas; 4) Integración opcional de visualización 3D, planos interactivos o recorridos virtuales; 5) Optimización de imágenes para velocidad de carga sin pérdida de calidad; 6) Filtros de búsqueda para que los visitantes encuentren referencias similares a sus necesidades; 7) Testimonios de clientes asociados a proyectos específicos; 8) Información sobre premios o reconocimientos obtenidos. La presentación estará diseñada para impresionar tanto a clientes como a otros profesionales del sector, con un enfoque que equilibra el impacto visual con la información técnica relevante. Te formaremos para que puedas actualizar fácilmente el portfolio con nuevos proyectos.",
      category: "Portfolio"
    },
    {
      question: "¿Cómo me ayudará la web a conseguir más clientes?",
      answer: "Tu web trabajará activamente para captar nuevos clientes mediante múltiples estrategias: 1) Posicionamiento SEO local para aparecer cuando busquen 'arquitecto en [tu ciudad]' o especialidades concretas; 2) Estructura optimizada para conversión con llamadas a la acción estratégicas que invitan al contacto; 3) Portfolio visual impactante que demuestra tu experiencia y estilo; 4) Integración con Google Business Profile para aparecer en búsquedas locales y mapas; 5) Contenidos de valor en blog que atraen tráfico cualificado y posicionan para términos específicos; 6) Presentación clara de servicios y especialidades que facilita que el cliente identifique si eres el profesional adecuado; 7) Testimonios y casos de éxito que generan confianza; 8) Formularios específicos por tipo de proyecto que califican leads; 9) Enlaces a redes sociales para amplificar tu presencia digital; 10) Sistema de citas online para consultas iniciales. Además, te proporcionaremos informes periódicos de rendimiento y recomendaciones para mejorar continuamente los resultados. Nuestros clientes arquitectos reportan un incremento medio del 35% en consultas cualificadas en los primeros 6 meses tras el lanzamiento de su web.",
      category: "Marketing"
    },
    {
      question: "¿Necesito proporcionar contenido profesional o lo hacéis vosotros?",
      answer: "Ofrecemos una solución flexible adaptada a tus necesidades: 1) Imágenes y material visual: Puedes proporcionar tus propias fotografías profesionales, renders y planos, o podemos recomendarte fotógrafos de arquitectura si necesitas realizar nuevas sesiones; 2) Textos descriptivos: Si dispones de descripciones técnicas de proyectos, las adaptaremos al formato web optimizado para SEO. Si no las tienes, realizaremos una entrevista detallada para crear contenidos profesionales; 3) Información sobre servicios: Te guiaremos mediante un cuestionario específico para arquitectos que nos permitirá redactar descripciones precisas y atractivas de tus servicios; 4) Biografía y perfil profesional: Adaptaremos tu CV o crearemos desde cero una presentación que destaque tu formación, enfoque y trayectoria; 5) Blog y contenidos adicionales: Podemos proporcionar artículos iniciales optimizados para SEO sobre temáticas relevantes de arquitectura. Lo ideal es una combinación donde tú aportas el conocimiento técnico y nosotros lo transformamos en contenido web efectivo. Para proyectos extensos, realizamos sesiones de trabajo específicas para recopilar toda la información necesaria de forma eficiente.",
      category: "Contenidos"
    },
    {
      question: "¿Cómo funcionará el mantenimiento de la web?",
      answer: "El mantenimiento mensual de 20€ incluye todos los aspectos técnicos y de soporte: 1) Alojamiento en servidores de alta velocidad optimizados para imágenes de arquitectura; 2) Renovación anual del dominio; 3) Certificado de seguridad SSL; 4) Copias de seguridad diarias; 5) Actualizaciones de seguridad y del sistema; 6) Soporte técnico por email y teléfono; 7) Pequeñas modificaciones de contenido (hasta 30 minutos mensuales); 8) Monitorización de rendimiento y disponibilidad. Además, te proporcionamos acceso a un panel de administración intuitivo donde podrás: añadir nuevos proyectos al portfolio, actualizar imágenes y descripciones, publicar entradas en el blog, y modificar información de contacto o servicios. Para estudios de arquitectura, incluimos una formación inicial personalizada para que tu equipo pueda mantener actualizado el portfolio sin depender constantemente de nosotros. Si necesitas modificaciones mayores o ampliaciones, disponemos de tarifas especiales para clientes de mantenimiento. El sistema está especialmente optimizado para gestionar eficientemente grandes cantidades de imágenes de alta resolución sin afectar al rendimiento.",
      category: "Mantenimiento"
    },
    {
      question: "¿Cómo captaré proyectos internacionales con la web?",
      answer: "Tu web se configurará estratégicamente para atraer proyectos internacionales mediante: 1) Estructura multiidioma opcional (inglés y español como estándar, otros idiomas disponibles según necesidad); 2) Posicionamiento SEO para términos específicos de arquitectura internacional; 3) Portfolio destacando proyectos realizados fuera de España (si los tienes); 4) Sección específica de servicios internacionales explicando tu metodología de trabajo remoto; 5) Presentación de certificaciones y homologaciones internacionales; 6) Referencias explícitas a tu disposición para proyectos en otros países; 7) Testimonios de clientes internacionales si están disponibles; 8) Integración con plataformas de comunicación como Zoom o Teams para reuniones virtuales; 9) Presentación de proceso de trabajo adaptado a clientes remotos; 10) Información clara sobre formas de pago internacionales. Si la expansión internacional es una prioridad para tu estudio, podemos desarrollar un plan específico de marketing digital internacional que complemente la web. Varios de nuestros clientes arquitectos han conseguido proyectos en Europa, Latinoamérica y Oriente Medio gracias a su presencia web estratégica, con incrementos en facturación internacional del 25-40% en el primer año.",
      category: "Proyección Internacional"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para arquitectos
      pageTitle="Web para Arquitectos desde 350€ | Portfolio Digital Profesional"
      pageDescription="Diseño web especializado para arquitectos y estudios. Portfolio visual de alto impacto, posicionamiento local y presencia profesional para captar proyectos de calidad."
      pageKeywords="página web barata arquitectos, web para arquitectos, portfolio arquitectura online, diseño web arquitectos, web estudio arquitectura"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-arquitectos"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para arquitectos desde 350€ (capta proyectos de mayor valor)"
      heroSubtitle="Portfolio digital profesional que exhibe tus proyectos con máximo impacto visual. Diseño exclusivo que refleja tu visión arquitectónica y atrae clientes de calidad."
      heroImage="/servicios/tipo-cliente/hero-arquitectos.webp"
      badges={['Desde 350€ (pago único)', 'Portfolio visual avanzado', 'Diseño exclusivo', 'Mantenimiento 20€/mes']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/contacto"
      
      // Secciones adaptadas
      pricingTitle="Planes para arquitectos y estudios"
      pricingSubtitle="Elige el plan que mejor se adapte a tus necesidades. Todos incluyen soporte técnico y mantenimiento por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestra web es ideal para arquitectos?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <FounderInsight 
          insightText={founderMessage}
          founderName="Miguel Vela"
          founderTitle="Co-fundador y Director de Desarrollo"
          avatarSrc="/sobre nosotros/foto-miguel.webp"
        />
      }
      
      processTitle="Creamos tu web en 3 sencillos pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos para tu web de arquitectura?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Ventajas de una web profesional para tu estudio"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para arquitectos"
      faqCategories={["Estrategia", "Portfolio", "Marketing", "Contenidos", "Mantenimiento", "Proyección Internacional"]}
      faqs={faqs}
      
      ctaTitle="Destaca en el competitivo sector de la arquitectura"
      ctaDescription="Una web profesional es hoy imprescindible para captar proyectos de calidad. Invierte en tu presencia digital y amplía tu alcance más allá de los contactos tradicionales."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/contacto"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebArquitectosPage; 

